import { WidgetRow } from '..'
import { Dictionary } from '../../../../base/store/state.interface'
import { WidgetHeightType, WidgetType } from './WidgetTypes'

export interface Widget {
  type: WidgetType,
  title: string,
  defaultSize?: number,
  size?: number,
  isFrameless?: boolean,
  noPadding?: boolean,
  minSize?: number,
  maxSize?: number,
  defaultHeightType?: WidgetHeightType,
  defaultHeight?: number,
  heightType?: WidgetHeightType,
  height?: number,
  minHeight?: number,
  rows?: WidgetRow[],
  sortindex?: number,
  wbUUID?: string,
  userCanAdd?: boolean,
  isTemplate?: boolean
  notEditable?: string[],
  icon?: string,
  customSettings?: WidgetSettingsDetails // keep in mind, that PermutatorService.syncWidgetCustomSettingField() might
                                         // needs to be updated if you make changes to the custom settings
  dataInitializer?: string
}

export type WidgetSettings = Dictionary<WidgetSettingsRadio | WidgetSettingsCheckbox | WidgetSettingsCheckboxList | WidgetSettingsText | WidgetSettingsNumber | WidgetSettingsCustom | WidgetSettingsSelectbox | WidgetSettingsSortableList | WidgetSettingsSortableCheckboxList>

export interface WidgetSettingsDetails {
  settings: WidgetSettings
  sections?: WidgetSettingsSection[]
}

export interface WidgetSettingsSection {
  label: string
  settings: string[]
}

export enum WidgetSettingType {
  radio = 'radio',
  checkbox = 'checkbox',
  checkboxList = 'checkboxList',
  text = 'text',
  number= 'number',
  selectbox = 'selectbox',
  custom = 'custom',
  sortableList = 'sortableList',
  sortableCheckboxList = 'sortableCheckboxList'
}

export interface WidgetSetting {
  title?: string
  type: WidgetSettingType
}

export interface WidgetSettingsRadio extends WidgetSetting {
  type: WidgetSettingType.radio
  checked: boolean
  value?: string | number
  group?: string
}

export interface WidgetSettingsCheckbox extends WidgetSetting {
  type: WidgetSettingType.checkbox
  checked: boolean
  value?: string | number
  disabled?: boolean
}

export interface WidgetSettingsText extends WidgetSetting {
  type: WidgetSettingType.text
  value: string
}

export interface WidgetSettingsNumber extends WidgetSetting {
  type: WidgetSettingType.number
  value: number
  min: number
  max: number
}

export interface WidgetSettingsSelectboxOption {
  label?: string
  value: string | number
}

export interface WidgetSettingsSelectbox extends WidgetSetting {
  name?: string
  type: WidgetSettingType.selectbox
  options: WidgetSettingsSelectboxOption[]
  value: string | number // readonly! auto populated in settings panel
}

export interface WidgetSettingsCustom extends WidgetSetting {
  type: WidgetSettingType.custom
  data: any
  template: string
}

export interface WidgetSettingsCheckboxList extends WidgetSetting {
  type: WidgetSettingType.checkboxList
  list: Dictionary<WidgetSettingsCheckbox>
  values: any[] // readonly! auto populated in settings panel
}

export interface WidgetSettingsSortableList extends WidgetSetting {
  title: string
  name: string
  type: WidgetSettingType.sortableList
  list: Array<string | number>
  values: any[] // readonly! auto populated in settings panel
}

export interface WidgetSettingsSortableCheckboxList extends WidgetSetting {
  title: string
  name: string
  type: WidgetSettingType.sortableCheckboxList
  list: Dictionary<WidgetSettingsCheckbox>
  values: any[] // readonly! auto populated in settings panel
}
